<template>
    <div>
      <carousel :per-page="1"
          :mouse-drag="false"
          :loop="true"
          :paginationEnabled="true"
          :autoplayTimeout="4000"
          :autoplay="true"
          :autoplayHoverPause="false">
        <slide>
          <p>Searching for an open,<br/> low cost ERP alternative?</p>
          <div class="img-container">
            <img src="../assets/images/antwebbuilding.gif"/>
          </div>
        </slide>
        <slide>
          <p>Ready for quality support <br/>with competitive rates?</p>
          <div class="img-container">
            <img src="../assets/images/antwebbuilding2.jpg"/>
          </div>
        </slide>
        <slide>
          <p>Proven, OFBiz/Moqui ERP implementation methodology.</p>
          <div class="img-container">
            <img src="../assets/images/antwebbuilding3.jpg"/>
          </div>
        </slide>
        <slide>
          <p>Transparent agile OFBiz<br> SW development method.</p>
          <div class="img-container">
            <img src="../assets/images/antwebbuilding4.jpg"/>
          </div>
        </slide>
      </carousel>
    </div>
</template>
<script>
    import { Carousel, Slide } from 'vue-carousel';
    export default {
        components: {
          Carousel,
          Slide
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/Slide.vue